const NotificationTypes = {
    SET_NOTIFICATION_FRANCH_PAYMENT: 'SET_NOTIFICATION_FRANCH_PAYMENT',
};

export default NotificationTypes;
